import CustomDynamicFieldSelect from "./CustomDynamicFieldSelect";

export { CustomDynamicFieldSelect as default };



// WEBPACK FOOTER //
// ./src/components/Document/DynamicField/CustomDynamicFieldSelect/index.js